import { RouterPath } from "@/models/enum/routerPath";
import RegisterCompanyView from "@/views/register-supplier/RegisterCompanyView.vue";
import AddColleaguesView from "@/views/register-supplier/AddColleaguesView.vue";
import WelcomeView from "@/views/register-supplier/WelcomeView.vue";

const registerSupplierRoutes = [
  {
    path: RouterPath.RegisterSupplierWelcome,
    name: RouterPath.RegisterSupplierWelcome,
    component: WelcomeView,
    meta: { disableBackButton: true },
  },
  {
    path: RouterPath.RegisterSupplierCompany,
    name: RouterPath.RegisterSupplierCompany,
    component: RegisterCompanyView,
    meta: { disableBackButton: true },
  },
  {
    path: RouterPath.AddColleaguesView,
    name: RouterPath.AddColleaguesView,
    component: AddColleaguesView,
    meta: { disableBackButton: true },
  },
];

export const allRegisterSupplierRoutes = registerSupplierRoutes.map((value) =>
  value.path.toString()
);

export default registerSupplierRoutes;
